import { useState } from 'react';
import { api, errMsg } from '../lib/api';
import { toast } from 'sonner';

const loadScript = () => new Promise((res) => {
  if (window.Razorpay) return res(true);
  const s = document.createElement('script');
  s.src = 'https://checkout.razorpay.com/v1/checkout.js';
  s.onload = () => res(true); s.onerror = () => res(false);
  document.body.appendChild(s);
});

export const RazorpayPayButton = ({ invoice, onPaid }) => {
  const [busy, setBusy] = useState(false);
  const pay = async () => {
    setBusy(true);
    try {
      const ok = await loadScript();
      if (!ok) { toast.error('Could not load Razorpay checkout'); setBusy(false); return; }
      const { data } = await api.post('/indiapay/order', { invoice_id: invoice.id });
      const rzp = new window.Razorpay({
        key: data.key_id, amount: data.amount, currency: data.currency, order_id: data.order_id,
        name: data.name, description: data.description, prefill: data.prefill,
        handler: async (res) => {
          try {
            const v = await api.post('/indiapay/verify', res);
            toast.success(`Payment received. Remaining balance: ${Number(v.data.balance).toLocaleString()}`);
            if (onPaid) onPaid();
          } catch (e) { toast.error(errMsg(e)); }
        },
      });
      rzp.open();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return <button data-testid={`pay-razorpay-${invoice.id}`} onClick={pay} disabled={busy} className="text-xs bg-blue-700 text-white rounded px-2 py-1 hover:bg-blue-600 transition-colors">UPI / Card</button>;
};
